import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export class GetCurrentUserResData extends ApiGenericResponse {
    currentUser: ClientUser;
    passwordValidDays: number = Number.MAX_VALUE;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.currentUser = ClientUser.parseFrom(response.data.Payload.CurrentUser);
            this.passwordValidDays = response.data.Payload.PasswordValidDays;
        }
    }
}
